import { api } from "api/api";
import { rejects } from "assert";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ItemEmprestimo from "model/patrimonio/ItemEmprestimo";
import { resolve } from "path";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ItemEmprestimoService implements BaseServiceCadastros<ItemEmprestimo> {
    
    pesquisar(page: Pageable,  filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/itemEmprestimo/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {reject(err.response);
                    console.error('Error status:', err.response?.status);
                    console.error('Error details:', err.response?.data);
                })
        });
    }

    consultar(id: number) {
        return new Promise<ItemEmprestimo>((resolve, reject): void => {
            api
                .get(`/itemEmprestimo/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(itemEmprestimo: ItemEmprestimo) {
        return new Promise<ItemEmprestimo>((resolve, reject): void => {
            api
                .post(`/itemEmprestimo/incluir`, JSON.stringify(itemEmprestimo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(itemEmprestimo: ItemEmprestimo) {
        return new Promise<ItemEmprestimo>((resolve, reject): void => {
            api
                .put(`/itemEmprestimo/editar`, JSON.stringify(itemEmprestimo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/itemEmprestimo/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    emprestar(itemEmprestimo: ItemEmprestimo) {
        return new Promise<ItemEmprestimo>((resolve, reject): void => {
            api
                .put(`/itemEmprestimo/emprestar`, JSON.stringify(itemEmprestimo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    devolvido(itemEmprestimo: ItemEmprestimo) {
        return new Promise<void>((resolve, reject): void => {
            api
                .put(`/itemEmprestimo/devolvido`, JSON.stringify(itemEmprestimo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    cancelar(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .put(`/itemEmprestimo/cancelar/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    pessoas() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/itemEmprestimo/pessoas`)
                .then((response) => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    produtos() {
        return new Promise<Produto[]>((resolve, reject): void => {
            api
                .get(`/itemEmprestimo/produtos`)
                .then((response) => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        })
    }

    getStatusLista(){
        return [{
                value: "CRIADO",
                label: "Criado"
            },
            {
                value: "EMPRESTADO",
                label: "Emprestado"
            },
            {
                value: "DEVOLVIDO",
                label: "Devolvido"
            },
            {
                value: "CANCELADO",
                label: "Cancelado"
            }]
    }

    getStatus(status: string): string {
        let statusObj = this.getStatusLista().find((item) => item.value === status)
        if (statusObj) {
            return statusObj.label
        }
        return "";
    }

    getListaStatusFilter() {
        return [
            { label: "Criado", value: "C" },
            { label: "Emprestado", value: "E" },
            { label: "Devolvido", value: "D" },
            { label: "Cancelado", value: "X" }
        ]
    }
}

export default ItemEmprestimoService;